import React from 'react';
import { Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { shape, string } from 'prop-types';
export const HeaderWithTooltip = ({ classes, label, tooltipTitle }) => (
  <div className={classes.helpIconContainer}>
    <div>
      {label}
    </div>
    <Tooltip
      title={tooltipTitle}
      arrow
      placement="right"
    >
      <HelpIcon className={classes.helpIcon} />
    </Tooltip>
  </div>
);

HeaderWithTooltip.propTypes = {
  classes: shape({}),
  label: string,
  tooltipTitle: string,
};

export default HeaderWithTooltip;